module.exports = __webpack_public_path__ + "img/geofisica_3-4_1152.a2c8508d.webp";